<style scoped>
.this__logo {
  height: 24px !important;
  width: auto !important;
  max-width: 120px;
}
</style>
<template>
  <a-col :lg="12" :xs="24">
    <div
      class="demo__ObjectBlock demo__BubbleBlock demo__BubbleBlock--col demo__margin-bottom__30 demo__flex demo__flex-between"
      v-bind:class="{
        ['skeleton-' + bg]: demo,
        ['demo__bg--' +
        (isMobile && bg === 'bgPlateDark' ? 'plateMobile' : bg)]: true,
        ['demo__color--' + color]: true,
      }"
      @click="$router.push(clickPath)"
    >
      <div class="demo__BubbleBlock_padding--v1 demo__flex demo__flex-column">
        <div
          class="demo__margin-bottom--10"
          v-if="object && object?.logoImage !== undefined"
        >
          <img
            class="this__logo"
            :src="$root.showLogic ? object?.logoImage || brandLogo : brandLogo"
          />
        </div>
        <div
          class="demo__font--18 demo__weight--600 demo__font-mobile--16 demo__ObjectBlock--title"
        >
          {{ title || object.title }}
        </div>
        <div
          class="demo__font--16 demo__font-mobile--14 demo__weight--400 demo__ObjectBlock--description"
          v-bind:class="{
            'demo__ObjectBlock--description--with-button':
              object.id && !isMobile,
          }"
        >
          <MobiledocText
            v-if="this.desc.mobiledoc"
            :mobiledoc="this.object[this.desc.field]"
          />
          <div v-else>
            {{ this.desc.value || this.object[this.desc.field] }}
          </div>
        </div>
        <div v-if="object.id && !isMobile" class="demo__flex-bottom">
          <div class="demo__margin-top--10">
            <a-button
              v-if="actionType === 'btn'"
              class="demo__button demo__button--base"
            >
              {{ $t("Go to") }}
              <i class="fa-light fa-chevron-right demo__margin-left--8"></i>
            </a-button>
            <div
              v-else-if="actionType === 'text'"
              class="demo__flex demo__flex-middle demo__hover"
            >
              <span class="demo__font--16 demo__weight--600">
                {{ $t("Go to") }}
              </span>
              <i
                class="fa-light fa-chevron-right demo__margin-left--8 demo__font--20"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <StatusBadge v-if="status" :status="status" position="right-top" />
      <div
        v-if="bgImage || object.backgroundImage"
        class="demo__flex demo__BubbleBlock--img demo__flex-space-around"
      >
        <div
          class="demo__BubbleBlock--img__inner"
          v-if="
            bgImage || object.backgroundImageBinary || object.backgroundImage
          "
          :style="{
            backgroundImage:
              'url(' +
              (bgImage ||
                object.backgroundImageBinary ||
                object.backgroundImage) +
              ')',
          }"
        ></div>

        <a-spin style="align-self: center" v-else> </a-spin>
      </div>
    </div>
  </a-col>
</template>

<script>
import { mapGetters } from "vuex";

import MobiledocText from "Components/MobiledocText/Viewer";
import StatusBadge from "Components/StatusBadge";

export default {
  components: {
    MobiledocText,
    StatusBadge,
  },
  props: {
    object: {
      required: true,
      type: Object,
    },
    demo: {
      required: false,
      default: false,
    },
    bg: {
      required: true,
      type: String,
    },
    color: {
      required: true,
      type: String,
    },
    desc: {
      required: true,
      type: Object,
    },
    clickPath: {
      required: true,
      type: String,
    },
    title: {
      required: false,
      type: String,
    },
    bgImage: {
      required: false,
    },
    status: {
      required: false,
      default: undefined,
    },
    actionType: {
      type: String,
      required: false,
      default: "btn",
    },
  },
  data() {
    return {
      brandLogo: require("@/assets/images/brand-logos/brand_logo_" +
        process.env.VUE_APP_INSTALLATION +
        ".svg"),
    };
  },
  computed: {
    ...mapGetters(["isMobile"]),
  },
  mounted() {
    this.$accessModule("object_block", this);
  },
  methods: {
    kitcut(text, limit) {
      if (!text) {
        return;
      }
      text = text.trim();
      if (text.length <= limit) return text;
      text = text.slice(0, limit); // тупо отрезать по лимиту
      var lastSpace = text.lastIndexOf(" ");
      if (lastSpace > 0) {
        // нашлась граница слов, ещё укорачиваем
        text = text.substr(0, lastSpace);
      }
      return text + "...";
    },
  },
};
</script>
